// extracted by mini-css-extract-plugin
export var active = "V_bd";
export var arrow = "V_9";
export var border = "V_dF";
export var button = "V_cf";
export var column = "V_dc";
export var columns = "V_db";
export var container = "V_b";
export var description = "V_dx";
export var dot = "V_dK";
export var footer = "V_cb";
export var footerText = "V_cc";
export var heading = "V_G";
export var icon = "V_bq";
export var includes = "V_dH";
export var info = "V_cy";
export var left = "V_bT";
export var mobileOption = "V_dJ";
export var option = "V_dC";
export var optionText = "V_dD";
export var options = "V_dB";
export var padding = "V_dQ";
export var plans = "V_dG";
export var popular = "V_dP";
export var price = "V_dL";
export var right = "V_cv";
export var section = "V_d";
export var show = "V_L";
export var subHeading = "V_H";
export var subText = "V_dN";
export var suffix = "V_dM";
export var title = "V_h";
export var waveOne = "V_q";
export var waveThree = "V_bZ";
export var waveTwo = "V_n";
export var waves = "V_bY";